'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
export const DepartureSubPageSkeleton: React.FC = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["my"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("my:sponsorshipRelationship.departures.subOverview.loading");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="DepartureSubOverview flex w-full flex-col gap-comfy-xl"><Skeleton height={24} width={180} /><Skeleton height={44} width="70%" /><Skeleton height={72} width="100%" /><Skeleton height={540} width="100%" borderRadius="1rem" /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex max-w-lg flex-col gap-comfy-lg"><Skeleton height={32} width="60%" /><Skeleton height={112} width="100%" /></div>;
    t4 = <Skeleton height={320} width="100%" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div aria-hidden="true" className="flex flex-col gap-roomy-sm">{t2}{t3}{t4}<div className="flex max-w-md flex-col gap-comfy-lg"><Skeleton height={32} width="55%" /><Skeleton height={160} width="100%" /></div></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1) {
    t6 = <section className="container mx-auto flex w-full flex-col gap-roomy-sm py-comfy-xl md:py-roomy-xs" aria-busy="true" aria-label={t1}>{t5}</section>;
    $[7] = t1;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};